import React from 'react';
import { useSelector } from 'react-redux';
import translate from '../../../config/translations/translate';
import ReviewLeaderboardStoreView from './ReviewLeaderboardStoreView';
import ReviewLeaderboardCompanyView from './ReviewLeaderboardCompanyView';
import { useState, useEffect } from 'react';
import { setSelectedStoreForReviewLeaderboard } from '../../../commons/components/application/applicationActions';
import { useDispatch } from 'react-redux';
import MobileScreenUnavailableMessage from '../../../commons/components/application/MobileScreenUnavailableMessage';
import { useNotificationTracking } from '../../../commons/utils/useNotificationTracking';
import withEventTracking from '../../../config/withEventTracking';

const ReviewLeaderBoardStandaloneScreen = ({t, trackEvent}) => {
    const selectedCompany = useSelector(state => state.application.selectedCompany);
    const admin = useSelector(state => state.login.admin);
    const availableStores = useSelector(state => state.application.availableStores);
    const [stores, setStores] = useState([]);
    const [selectedStore, setSelectedStore] = useState(null);
    const isCompanyAccess = admin.objectAccess === "COMPANY" || admin.objectAccess === "ALL";
    const dispatch = useDispatch();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);  
    const [isMobileModalOpen, setIsMobileModalOpen] = useState(window.innerWidth < 1050);
    useNotificationTracking(trackEvent, 'review_leaderboard');

    useEffect(() => {
        const filteredStores = availableStores.filter(store => store.companyId === selectedCompany.id);
        setStores(filteredStores);
        setSelectedStore(filteredStores[0]);
        setIsMobileModalOpen(window.innerWidth < 1050);
      }, [availableStores, selectedCompany])

    useEffect(() => {
    const filteredStores = availableStores.filter(store => store.companyId === selectedCompany.id);
    setStores(filteredStores);
    setSelectedStore(filteredStores[0]);
    
    
    }, [availableStores, selectedCompany])

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (windowWidth < 1050) {
            setIsMobileModalOpen(true);
        } else {
            setIsMobileModalOpen(false);
        }
    }, [windowWidth]);

    const handleStoreChange = (event) => {
        const storeId = parseInt(event.target.value);
        const store = stores.find(store => store.id === storeId);
        dispatch(setSelectedStoreForReviewLeaderboard(store));
        setSelectedStore(store);
    };

    return (
        <>
            <MobileScreenUnavailableMessage isOpen={isMobileModalOpen} />
            {isCompanyAccess && stores.length > 0 && 
            <ReviewLeaderboardCompanyView
                companyId={selectedCompany && selectedCompany.id}
                companyName={selectedCompany && selectedCompany.name}
                t={t}
                stores={stores}
                selectedStore={selectedStore}
                handleStoreChange={handleStoreChange}
            />}
                
            { !isCompanyAccess && selectedStore && 
            <ReviewLeaderboardStoreView
                storeId={selectedStore && selectedStore.id}
                storeName={selectedStore && selectedStore.name}
                t={t}
                stores={stores}
                selectedStore={selectedStore}
                handleStoreChange={handleStoreChange}
                showStoreSelector={stores.length > 1}
            />} 

        </>
    );
    
};

export default withEventTracking(translate(ReviewLeaderBoardStandaloneScreen));
